/* eslint-disable no-plusplus */
/* eslint-disable no-unused-expressions */
/* eslint-disable no-restricted-syntax */
/* eslint-disable react/no-access-state-in-setstate */
/* eslint-disable react/jsx-one-expression-per-line */
import React, { Component } from 'react'
import { Typography, Divider, Row, Table, TimePicker, Button, notification, Form } from 'antd'
import moment from 'moment'
import { Link } from 'react-router-dom'
import API from '../../services/API'
// eslint-disable-next-line no-unused-vars
import Segment from '../../components/Segment'
// eslint-disable-next-line prefer-destructuring
// const Option = Select.Option

const { Paragraph } = Typography
const DAYS = {
    L: 'Lunes',
    M: 'Martes',
    Mi: 'Miercoles',
    J: 'Jueves',
    V: 'Viernes',
    S: 'Sabado',
    D: 'Domingo',
}

class UsersScheduleContainer extends Component {
    constructor(props) {
        super()
        this.id = props.match.params.id
    }

    // eslint-disable-next-line react/state-in-constructor
    state = {
        loading: true,
        user: null,
        schedule: null,
    }

    componentDidMount() {
        this.fetchData()
    }

    fetchData = async () => {
        try {
            const response = await Promise.all([
                API.get(`/api/users/${this.id}`),
                API.get(`/api/users/${this.id}/schedule`),
            ])
            const [userRes, scheduleRes] = response
            this.setState({
                user: userRes.data,
                schedule: scheduleRes.data.payload,
            })
        } catch (e) {
            console.error(e)
        } finally {
            this.setState({ loading: false })
        }
    }

    transformData = schedule => {
        const copy = { ...schedule }
        const deleted = []
        for (const [key, dayData] of Object.entries(schedule)) {
            if (!dayData.IN || !dayData.OUT_LUNCH || !dayData.IN_LUNCH || !dayData.OUT) {
                deleted.push(key)
                delete copy[key]
            }
        }
        return [copy, deleted]
    }

    validateData = schedule => {
        let valid = true
        for (const [day, dayData] of Object.entries(schedule)) {
            let counter = 0
            !dayData.IN && counter++
            !dayData.OUT_LUNCH && counter++
            !dayData.IN_LUNCH && counter++
            !dayData.OUT && counter++
            if (counter > 0 && counter < 4) {
                valid = false
                notification.error({
                    message: `Error en día ${DAYS[day]}`,
                    description: 'Se debe completar los 4 horarios antes de guardar',
                })
            }
        }
        return valid
    }

    save = async () => {
        this.setState({
            loading: true,
        })

        if (!this.validateData(this.state.schedule)) {
            this.setState({
                loading: false,
            })
            return
        }

        const [schedule, deleted] = this.transformData(this.state.schedule)

        const data = {
            schedule,
            deleted,
        }
        try {
            const response = await API.post(`/api/users/${this.id}/schedule`, data)
            console.log(response)
            notification.success({
                message: 'El horario se ha guardado exitosamente',
            })
        } catch (error) {
            if (error.response) {
                notification.error({
                    message: `Error ${error.response.status}`,
                    description: error.response.data.message,
                })
            } else if (error.request) {
                notification.error({
                    message: 'No se recibió respuesta del servidor',
                })
            } else {
                notification.error({
                    message: 'Error desconocido',
                })
            }
        } finally {
            this.setState({
                loading: false,
            })
        }
    }

    handleTimeChange = (day, type, hour) => {
        let newDay

        if (!hour) {
            newDay = {
                ...this.state.schedule[day],
                IN: null,
                OUT_LUNCH: null,
                IN_LUNCH: null,
                OUT: null,
            }
        } else {
            newDay = {
                ...this.state.schedule[day],
                [type]: hour.format('HH:mm:ss'),
            }
        }

        this.setState({
            schedule: {
                ...this.state.schedule,
                [day]: newDay,
            },
        })
    }

    TimePicker = (record, key) => {
        const value = key in record && record[key] ? moment(record[key], 'HH:mm:ss') : null
        return (
            <TimePicker
                placeholder="hh:mm:ss"
                value={value}
                onChange={val => this.handleTimeChange(record.day, key, val)}
            />
        )
    }

    getData = schedule => [
        { ...schedule.L },
        { ...schedule.M },
        { ...schedule.Mi },
        { ...schedule.J },
        { ...schedule.V },
        { ...schedule.S },
        { ...schedule.D },
    ]

    render() {
        const columns = [
            {
                title: 'Día',
                dataIndex: 'day',
                sorter: false,
                render: (label, record) => DAYS[record.day],
            },
            {
                title: 'Entrada',
                sorter: false,
                render: (label, record) => this.TimePicker(record, 'IN'),
            },
            {
                title: 'Salida (comida)',
                sorter: false,
                render: (label, record) => this.TimePicker(record, 'OUT_LUNCH'),
            },
            {
                title: 'Entrada (comida)',
                sorter: false,
                render: (label, record) => this.TimePicker(record, 'IN_LUNCH'),
            },
            {
                title: 'Salida',
                sorter: false,
                render: (label, record) => this.TimePicker(record, 'OUT'),
            },
        ]
        return (
            <Segment loading={this.state.loading}>
                <Divider>Horario del usuario</Divider>
                <Form style={{ maxWidth: '800px', margin: 'auto' }}>
                    <Button
                        size="large"
                        style={{ margin: '10px' }}
                        onClick={() => {
                            const newShedule = {}
                            for (const [key, value] of Object.entries(DAYS)) {
                                newShedule[key] = {
                                    day: key,
                                    IN: '08:00:00',
                                    OUT_LUNCH: '10:00:00',
                                    IN_LUNCH: '10:30:00',
                                    OUT: '16:00:00',
                                }
                            }

                            this.setState({
                                schedule: newShedule,
                            })
                        }}
                    >
                        Matutino
                    </Button>

                    <Button
                        size="large"
                        style={{ margin: '10px' }}
                        onClick={() => {
                            const newShedule = {}
                            for (const [key, value] of Object.entries(DAYS)) {
                                newShedule[key] = {
                                    day: key,
                                    IN: '16:00:00',
                                    OUT_LUNCH: '18:00:00',
                                    IN_LUNCH: '18:30:00',
                                    OUT: '22:00:00',
                                }
                            }

                            this.setState({
                                schedule: newShedule,
                            })
                        }}
                    >
                        Vespertino
                    </Button>

                    <Button
                        size="large"
                        style={{ margin: '10px' }}
                        onClick={() => {
                            const newShedule = {}
                            for (const [key, value] of Object.entries(DAYS)) {
                                newShedule[key] = {
                                    day: key,
                                    IN: '10:00:00',
                                    OUT_LUNCH: '14:00:00',
                                    IN_LUNCH: '16:00:00',
                                    OUT: '22:00:00',
                                }
                            }

                            this.setState({
                                schedule: newShedule,
                            })
                        }}
                    >
                        Gerente
                    </Button>

                    {this.state.schedule && this.state.user ? (
                        <>
                            <Paragraph style={{ textAlign: 'center' }} strong={true}>
                                {this.state.user.full_name} | {this.state.user.email}
                            </Paragraph>
                            <Table
                                columns={columns}
                                rowKey={row => row.id}
                                dataSource={this.getData(this.state.schedule)}
                                bordered
                                size="small"
                            />
                        </>
                    ) : null}

                    <Row type="flex" justify="space-between" style={{ marginTop: '50px' }}>
                        <Form.Item>
                            <Link to="/users">
                                <Button icon="arrow-left">Regresar</Button>
                            </Link>
                        </Form.Item>
                        <Form.Item>
                            <Button type="primary" icon="save" onClick={this.save}>
                                Guardar
                            </Button>
                        </Form.Item>
                    </Row>
                </Form>
            </Segment>
        )
    }
}

export default UsersScheduleContainer
